import CreateAgendaItemData from "@/domain/entities/agenda/CreateAgendaItemData";
import { CreateAgendaItemData as CreateAgendaItemDataSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const createAgendaItemDataToSDKMapper = (
    createAgendaItemData: CreateAgendaItemData,
): CreateAgendaItemDataSDK => ({
    subject: createAgendaItemData.subject,
    description: createAgendaItemData.description,
    location: createAgendaItemData.location,
    start: createAgendaItemData.start,
    end: createAgendaItemData.end,
    isAllDay: createAgendaItemData.isAllDay,
    attendees: createAgendaItemData.attendees,
});

export default createAgendaItemDataToSDKMapper;
